import axios from 'axios';

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

API.interceptors.request.use((config) => {
  const t = localStorage.getItem('shop_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

API.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && window.location.pathname.startsWith('/shop')
        && !window.location.pathname.startsWith('/shop/login')
        && !window.location.pathname.startsWith('/shop/setup')) {
      localStorage.removeItem('shop_token');
      window.location.href = '/shop/login';
    }
    return Promise.reject(e);
  }
);

export const fmt = (n) =>
  '€ ' + Number(n || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');

/** Pas de primaire shop-kleur dynamisch toe als CSS-variabelen.
 *  - --shop-primary: hoofdkleur uit Instellingen → Branding → Primaire kleur
 *  - --shop-primary-dark: 15 % donkerder voor hover-states
 */
export function applyShopTheme(primary) {
  const c = (primary && /^#[0-9a-fA-F]{6}$/.test(primary)) ? primary : '#002FA7';
  const dark = shade(c, -0.15);
  const root = document.documentElement;
  root.style.setProperty('--shop-primary', c);
  root.style.setProperty('--shop-primary-dark', dark);
}

function shade(hex, pct) {
  const num = parseInt(hex.slice(1), 16);
  const r = Math.max(0, Math.min(255, Math.round(((num >> 16) & 0xff) * (1 + pct))));
  const g = Math.max(0, Math.min(255, Math.round(((num >> 8) & 0xff) * (1 + pct))));
  const b = Math.max(0, Math.min(255, Math.round((num & 0xff) * (1 + pct))));
  return '#' + [r, g, b].map((v) => v.toString(16).padStart(2, '0')).join('');
}

export default API;
